<script context="module">"use strict";
let counter = 0;
</script>

<script>import { createEventDispatcher } from 'svelte';
import { combineValidators } from '../validation';
export let bindGroup = [];
export let type = 'checkbox', name = `input${type}_${counter}`, label = '', value = '', cssClass = '', containerCssClass = '', inputStyle = '', disabled = false, error = null;
export let id = `input_${type}_${name}_${counter}`;
counter++;
const dispatch = createEventDispatcher();
const onChange = ({ target }) => {
    const { value, checked } = target;
    if (checked) {
        bindGroup = [...bindGroup, value];
    }
    else {
        bindGroup = bindGroup.filter((item) => item !== value);
    }
    dispatch('change', { value, checked });
};
export let validators = [];
export const validate = async () => {
    try {
        await combineValidators(...validators)(label, bindGroup);
        error = null;
    }
    catch (e) {
        const errorObject = e;
        error = errorObject.message || 'Unknown error';
        throw e;
    }
};
</script>

<div class={containerCssClass}>
    <label for={id}>
        <input
            type="checkbox"
            checked={bindGroup.includes(value)}
            on:change={onChange}
            {id}
            {name}
            {value}
            class={cssClass}
            class:validation_error={error}
            {disabled}
            style={inputStyle}
        />
        {@html label}
    </label>
    {#if error}
        <span class="error">{error}</span>
    {/if}
</div>
